import React from 'react';

export function IntroSection() {
  const scrollToContact = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const contactSection = document.getElementById('contact-section');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const domains = [
    { icon: 'ri-t-shirt-line', label: 'Fashion Brands', target: 'offers-section' },
    { icon: 'ri-building-2-line', label: 'Hotels', target: 'hotel-section' },
    { icon: 'ri-restaurant-line', label: 'Restaurants', target: 'hospitality-section' },
  ];

  const scrollToSection = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <section className="py-12 md:py-20 px-4 md:px-6 bg-white">
      <div className="max-w-5xl mx-auto">
        <div className="grid md:grid-cols-2 gap-8 md:gap-12 items-start">
          {/* Left Column - Title */}
          <div>
            <h2 className="text-3xl md:text-5xl lg:text-6xl font-serif font-light mb-4 md:mb-6">
              Our Vision
            </h2>
            <h3 className="text-2xl md:text-3xl lg:text-4xl font-serif font-light text-gray-600 leading-relaxed">
              elegant<br />
              fashion-inspired<br />
              touching
            </h3>
          </div>

          {/* Right Column - Text */}
          <div>
            <div className="w-16 h-px bg-gray-300 mb-6 md:mb-8"></div>
            <p className="text-sm md:text-base leading-relaxed text-gray-700 mb-6 md:mb-8">
              In the heart of the City of Light, PRV Creative elevates your brand with borderless distinction. We orchestrate high-end productions for <strong>fashion houses</strong>, <strong>luxury hotels</strong>, and <strong>fine dining establishments</strong> — where Parisian refinement meets bold, modern storytelling. Through our mastery, we capture the elusive: that touch of timeless chic for your most demanding global campaigns.
            </p>

            {/* Domain pills */}
            <div className="flex flex-wrap gap-3 mb-8 md:mb-10">
              {domains.map((d) => (
                <button
                  key={d.label}
                  onClick={() => scrollToSection(d.target)}
                  className="flex items-center gap-2 px-4 py-2 border border-gray-200 text-gray-600 text-xs uppercase tracking-wider hover:border-gray-800 hover:text-gray-900 transition-all duration-300 cursor-pointer whitespace-nowrap"
                >
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className={`${d.icon} text-sm`}></i>
                  </div>
                  {d.label}
                </button>
              ))}
            </div>

            <a
              href="#contact-section"
              onClick={scrollToContact}
              className="inline-block px-6 md:px-8 py-3 bg-gray-800 text-white text-xs md:text-sm uppercase tracking-wider hover:bg-gray-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us!
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
